import { Grid, Container } from "@mui/material";
import { AboutJoinContent, AboutJoinImage } from "@/components/ui";

export const AboutJoin = () => {
  return (
    <Container maxWidth="lg">
      <Grid
        container
        spacing={6}
        sx={{
          alignItems: "center",
          py: { xs: 6, md: 12 },
        }}
      >
        <AboutJoinContent />
        <AboutJoinImage />
      </Grid>
    </Container>
  );
};
